import React from 'react';
import styles from './Divider.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const Divider = () => {
  return (
    <div className={cx('Divider')}/>
  );
};

export default Divider;